/* @flow */

import * as React from 'react';

import { formatNumber, DASH } from '../utils/number';

export type Props = {
  tickSizes: Object,
  cellData: Object,
};

const getComparison = (side, type) => {
  if (
    (side === 'BUY' && type === 'STOP_LOSS_LIMIT') ||
    (side === 'SELL' && type === 'TAKE_PROFIT_LIMIT')
  ) {
    return '>=';
  }
  if (
    (side === 'BUY' && type === 'TAKE_PROFIT_LIMIT') ||
    (side === 'SELL' && type === 'STOP_LOSS_LIMIT')
  ) {
    return '<=';
  }
  return DASH;
};

const StopLimitTrigger = (props: Props) => {
  const { tickSizes, cellData } = props;
  const comparison = getComparison(cellData.side, cellData.type);
  const number =
    comparison === DASH ? '' : ` ${formatNumber(cellData.stopPrice, tickSizes[cellData.symbol])}`;
  return <span>{`${comparison}${number}`}</span>;
};

export default StopLimitTrigger;
